import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks';

import { useStyles } from './useStyles';

export const CardTitle = ({ user, title }) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const classes = useStyles();

  return (
    <Box className={classes.headerTitle}>
      {isMobile ? (
        <>
          <Text size="xl" color="focus00" className={classes.headerUser}>{user}</Text>
          <Text size="xl" color="focus00" className={classes.headerText}>{title}</Text>

        </>
      )
        : (
          <>
            <Title variant="sm" color="focus00" className={classes.headerUser}>{user}</Title>
            <Title variant="sm" color="focus00" className={classes.headerText}>{title}</Title>
          </>
        )}
    </Box>
  );
};

CardTitle.propTypes = {
  user: PropTypes.string,
  title: PropTypes.string
};

CardTitle.defaultProps = {
  user: 'User',
  title: 'Title'
};
